import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import FilterList, { FilterValues } from 'projects/access-control/src/app/Domain/Entities/filter-list.interface';
import { Groups } from 'projects/access-control/src/app/Domain/Entities/group.interface';
import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';
import { ModalAddFieldComponent } from 'projects/access-control/src/app/UI/components/modal-add-field/modal-add-field.component';
import { ModalDesignFormComponent } from 'projects/access-control/src/app/UI/components/modal-design-form/modal-design-form.component';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { DataPagination } from '../../../../../Domain/Adapters';

@Component({
	selector: 'app-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
	@Input() group: Groups = {} as Groups;
	disabledRefresh = true;
	pagination: DataPagination = {} as DataPagination;
	fieldTable: any = [];
	columns = [{ name: 'Name' }, { name: 'Email' }, { name: 'Status' }];
	modeColum!: any;
	filterResults: FilterValues[] = [] as FilterValues[];
	filterList: FilterList[] = [];
	constructor(public dialog: MatDialog) {}

	ngOnInit(): void {
		this.modeColum = ColumnMode.force;
	}

	buttonAction(option: string) {
		if (option === 'refresh') {
			this.disabledRefresh = true;
		} else if (option === 'add') {
			this.addFields();
		}
	}

	refreshData(event: any) {}

	emitNavigation(numberPage: number) {
		// this.store.dispatch(getCampaigns({ pageToNation: numberPage }));
	}
	addFields() {
		const dialogRef = this.dialog.open(ModalAddFieldComponent, {
			height: '450px',
			width: '687px',
			// data: { type, group: this.group },
		});
		dialogRef.afterClosed().subscribe((result) => {
			this.fieldTable.push(result);
			this.fieldTable = [...this.fieldTable];
		});
	}
	desingForm() {
		const dialogRef = this.dialog.open(ModalDesignFormComponent, {
			height: '95vh',
			width: '1000px',
			disableClose: true,
			// data: { type, group: this.group },
		});
	}
}
